import React from "react";
import CardUI from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import TitleIcon from "@material-ui/icons/BarChart";
import GeslubLogo from "../../assets/logos/geslub/geslub_simbolo_version_principal.png";

type Types = "principal" | "dashboard" | "none";

interface MainDrawerContainerProps {
  type?: Types;
  children?: React.ReactNode;
  title?: string;
  style?: React.CSSProperties;
}

const useStyles = makeStyles({
  card: {
    width: "100%",
  },
});

/**
 * Container of the main drawer
 *
 */
export const Card = ({
  type = "none",
  title,
  children,
  style,
}: MainDrawerContainerProps): React.ReactElement => {
  const classes = useStyles();

  if (type === "principal")
    return (
      <CardUI className={classes.card} style={style}>
        <CardContent>
          <span
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              flexDirection: "row",
              marginBottom: "3%",
              marginTop: "1%",
            }}>
            <Typography
              variant="h3"
              color="primary"
              style={{ fontWeight: "bold" }}>
              {title}
            </Typography>
          </span>
          {children}
        </CardContent>
      </CardUI>
    );

  if (type === "dashboard")
    return (
      <CardUI className={classes.card} style={style}>
        <CardContent>
          <span
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              flexDirection: "row",
              marginBottom: "3%",
              marginTop: "1%",
              backgroundColor: "#f8f8f8",
              padding: 10,
              overflowX: "auto",
            }}>
            <img
              src={GeslubLogo}
              height="150vh"
              width="150vw"
              alt="Icono de Geslub"
            />
            <div>
              <Typography
                variant="h4"
                color="primary"
                style={{ fontWeight: "bold", marginLeft: "0.4em" }}>
                Geslub Dashboard
              </Typography>
              <Typography
                variant="h5"
                color="primary"
                style={{ marginLeft: "0.6em" }}>
                Belray Ventec
              </Typography>
            </div>
          </span>

          {children}
        </CardContent>
      </CardUI>
    );

  return (
    <CardUI className={classes.card} style={style}>
      {children}
    </CardUI>
  );
};
